export default __webpack_public_path__ + "1-9b3a9f5a44c372335c7ed89dbccb35fd.jpg";